var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blank-document-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blank-document-icon-group2",
    transform: "translate(-322.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blank-document-icon-group3",
    transform: "translate(322.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blank-document-icon-rect1",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9574468,4.08510638 L12.1276596,4.08510638 C9.95106383,4.08510638 8.19,5.87744681 8.19,8.06808511 L8.17021277,39.9319149 C8.17021277,42.1225532 9.9312766,43.9148936 12.1078723,43.9148936 L35.8723404,43.9148936 C38.0489362,43.9148936 39.8297872,42.1225532 39.8297872,39.9319149 L39.8297872,16.0340426 L27.9574468,4.08510638 Z M35.8723404,39.9319149 L12.1276596,39.9319149 L12.1276596,8.06808511 L25.9787234,8.06808511 L25.9787234,18.0255319 L35.8723404,18.0255319 L35.8723404,39.9319149 Z",
    id: "blank-document-icon-path1",
    fill: "#8996A4",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankDocumentIcon);
export default __webpack_public_path__ + "static/media/blank-document-icon.7e8fe530.svg";
export { ForwardRef as ReactComponent };